import BaseComponent from "../../BaseComponent";
import iziToast from "izitoast";

export default class ChatbotModeration extends BaseComponent {

    private loadSuggestionsUrl: string | null = null;
    private status: string | null = null;
    private suggestionsIntervalId: number | null = null;
    private isLoadingSuggestions: boolean = false;
    private readonly pollingInterval: number = 2000;
    private lastPendingCommentIds: string[] = [];
    private noUpdateResponseCount: number = 0;
    private readonly noUpdateResponseLimit: number = 20;

    public init(): void {
        this.loadSuggestionsUrl = this.$component.data('load-suggestions-url');
        if (!this.loadSuggestionsUrl) {
            throw new Error('Suggestions URL is missing.');
        }

        this.status = this.$component.data('status');

        if (this.status === 'loading') {
            this.startSuggestionsPolling();
        }
    }

    private startSuggestionsPolling(): void {
        this.stopSuggestionsPolling();

        this.suggestionsIntervalId = window.setInterval(() => {
            this.loadSuggestions();
        }, this.pollingInterval);
    }

    private stopSuggestionsPolling(): void {
        if (this.suggestionsIntervalId !== null) {
            clearInterval(this.suggestionsIntervalId);
            this.suggestionsIntervalId = null;
        }
    }

    private loadSuggestions(): void {
        if (this.isLoadingSuggestions) {
            return;
        }

        this.isLoadingSuggestions = true;

        this.context.naja.makeRequest('POST', this.loadSuggestionsUrl)
            .then(response => {
                this.checkNoUpdateResponseLimit(response);

                if (response.pendingCommentIds.length === 0) {
                    this.stopSuggestionsPolling();
                    this.tryInitSuggestionPaginator();
                }
            })
            .catch(error => {
                this.stopSuggestionsPolling();
                console.error('Failed to load suggestions:', error);
                window.alert('An error occurred while generating suggestions. Please try again later.');
            })
            .finally(() => {
                this.isLoadingSuggestions = false;
            });
    }

    private checkNoUpdateResponseLimit(response: any): void {
        const currentPendingCommentIds: string[] = response.pendingCommentIds;

        if (JSON.stringify(this.lastPendingCommentIds) === JSON.stringify(currentPendingCommentIds)) {
            this.noUpdateResponseCount++;
        } else {
            this.noUpdateResponseCount = 0;
            this.lastPendingCommentIds = currentPendingCommentIds;
        }

        if (this.noUpdateResponseCount >= this.noUpdateResponseLimit) {
            this.stopSuggestionsPolling();
            iziToast.error({message: 'Moderation guide timed out. Please try again later.', timeout: false});
        }
    }

    private tryInitSuggestionPaginator(): void {
        const $comments = this.$component.find('[data-comments]');
        if ($comments.length === 0) {
            return;
        }

        const $prevCommentButton = this.$component.find('[data-prev-comment]');
        const $nextCommentButton = this.$component.find('[data-next-comment]');

        const commentIds = $comments.data('comments');
        const commentCount = commentIds.length;
        let selectedCommentIndex = 0;
        let selectedCommentElement: HTMLElement|null = null;

        function changeSelectedComment(): void {
            if (selectedCommentElement) {
                selectedCommentElement.classList.remove('border-suggestion');
            }

            $comments.text(`${selectedCommentIndex + 1} / ${commentCount}`);

            const id: string = 'comment-' + commentIds[selectedCommentIndex];
            selectedCommentElement = document.getElementById(id);
            if (selectedCommentElement) {
                selectedCommentElement.scrollIntoView({block: "center"});
                selectedCommentElement.classList.add('border-suggestion');
            }
        }

        changeSelectedComment();

        $prevCommentButton.on('click', () => {
            selectedCommentIndex = Math.max(0, selectedCommentIndex - 1);
            changeSelectedComment();
        });

        $nextCommentButton.on('click', () => {
            selectedCommentIndex = Math.min(commentCount - 1, selectedCommentIndex + 1);
            changeSelectedComment();
        });

        $('.chatbot-icon').on('click', '[data-close-button]', () => {
            if (selectedCommentElement) {
                selectedCommentElement.classList.remove('border-suggestion');
            }
        });
    }

}